import React from 'react';

import { useClientContext } from '../../../contexts/ClientContext';
import MapOnDemandClientTemplate from '../templates';

const MapOnDemandClient = () => {
  const client = useClientContext();

  const handleClientIdChange = (e) => {
    client.setClientId(e.target.value);
  };

  const handleClientSubmit = () => {
    client.getClientInfo();
  };

  return (
    <MapOnDemandClientTemplate
      button={{
        label: 'Submit',
        onClick: handleClientSubmit,
      }}
      input={{
        value: client.clientId,
        onChange: handleClientIdChange,
        name: 'clientId',
        placeHolder: 'Enter Client ID',
      }}
      header={{
        value: 'Client ID',
      }}
      label={{
        value: client.client.label,
      }}
    />
  );
};

export default MapOnDemandClient;
